import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import TopNav from './components/TopNav';
import {MiniContactBar} from './components/MiniContactBar'
import BottomNav from './components/BottomNav'
import Home from './pages/Home'
import AboutMe from './pages/AboutMe'
import Portfolio from './pages/Portfolio'
import Contact from './pages/Contact'

class App extends Component {
  render() {
    return (
      <Router>
        <>
          <TopNav />
          <MiniContactBar />
          <Route exact path="/" component={Home} />
          <Route exact path="/about" component={AboutMe} />
          <Route exact path="/portfolio" component={Portfolio} />
          <Route exact path="/contact" component={Contact} />
          <BottomNav />
        </>
      </Router>
    );
  }
}

export default App;
